export default __webpack_public_path__ + "static/media/diamond-clarity_over-md@2x.ad0e0200.png";